import React, { useEffect, useState } from 'react'
import ModalWrapper from '../../../../../../Components/CustomModal/ModalWrapper'
import { useDispatch, useSelector } from 'react-redux';
import { MultiSelect } from 'primereact/multiselect';
import { getPoNo } from '../../../../../../Store/prosafe/proTransaction/PurReceive/getPoNo';
import { getPoNoItems } from '../../../../../../Store/prosafe/proTransaction/PurReceive/getPoNoItems';
import { Pencil, Save, Trash2, X } from 'lucide-react';
import toast from 'react-hot-toast';
import { V_URL } from '../../../../../../BaseUrl';
import axios from 'axios';
import { getViewReceiveItems } from '../../../../../../Store/prosafe/proTransaction/PurReceive/getViewReceiveItems';

const AutoReceiveModel = ({ modal, setItemsArr, itemsArr, form, data }) => {

  const dispatch = useDispatch();
  const [autoItemsData, setAutoItemsData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [isEditing, setIsEditing] = useState(true);
  const [selectedPo, setSelectedPo] = useState([]);

  const poNoData = useSelector((state) => state?.getPoNo?.user?.data);
  const poItemsData = useSelector((state) => state?.getPoNoItems?.user?.data);

  useEffect(() => {
    if (form.party_id && form.project_id) {
      const formData = new URLSearchParams({
        tag_number: 10,
        firm_id: localStorage.getItem('PAY_USER_FIRM_ID'),
        year_id: localStorage.getItem('PAY_USER_YEAR_ID'),
        project_id: form.project_id,
        party_id: form.party_id,
      });
      dispatch(getPoNo({ formData }));
    }
  }, [form.party_id, form.project_id]);

  useEffect(() => {
    if (form.party_id && form.project_id) {
      const formData = new URLSearchParams({
        tag_number: 10,
        firm_id: localStorage.getItem('PAY_USER_FIRM_ID'),
        year_id: localStorage.getItem('PAY_USER_YEAR_ID'),
        project_id: form.project_id,
        party_id: form.party_id,
        po_no: JSON.stringify(selectedPo),
      });
      dispatch(getPoNoItems({ formData }));
    }
  }, [form.party_id, form.project_id, selectedPo]);

  const recalculate = (item) => {
    const { require_qty = 0, rate = 0, gst = 0, discount = 0, sp_discount = 0 } = item;
    const amount = require_qty * rate;
    const discount_amount = (amount * discount) / 100;
    const sp_discount_amount = ((amount - discount_amount) * sp_discount) / 100;
    const taxable_amount = amount - discount_amount - sp_discount_amount;
    const gst_amount = (taxable_amount * gst) / 100;
    const total_amount = taxable_amount + gst_amount;
    return { ...item, amount, discount_amount, sp_discount_amount, taxable_amount, gst_amount, total_amount };
  };

  useEffect(() => {
    if (!modal.isShown) {
      setAutoItemsData([]);
      setOriginalData([]);
      setSelectedPo([]);
      // setIsEditing(false);
    }
  }, [modal.isShown]);

  const calculatePendingQuantity = (prItem) => {
    const matchingItems = itemsArr?.filter(item =>
      // item.from_id === prItem?.from_id &&
      item.detail_id === prItem?.detail_id &&
      item.item_id === prItem?.item_data?._id
    );
    // Calculate total quantity already added
    const totalAdded = matchingItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
    // Return remaining quantity (original quantity - already added)
    // return (prItem.quantity || 0) - totalAdded;
    // EDIT TIME MANAGE THE ORIGNAL QTY - USED AND NEW DATA THEN DIRECT BALANCE QTY
    return (data?._id ? prItem.original_quantity : prItem.quantity) - totalAdded;
  };

  useEffect(() => {
    if (Array.isArray(poItemsData)) {
      const mappedItems = poItemsData?.filter(e => {
        const pendingQty = calculatePendingQuantity(e);
        return pendingQty > 0 || !itemsArr?.some(item =>
          item.from_id === e?.from_id &&
          item.detail_id === e?.detail_id &&
          item.item_id === e?.item_data?._id
        );
      })?.map((e) => {
        const pendingQty = calculatePendingQuantity(e);
        const qty = e.quantity || 0;
        const rate = e.rate || 0;
        const gst = e.gst || 0;
        const base = {
          ...e,
          item: e.item_data?.name,
          item_id: e.item_data?._id,
          require_qty: 0,
          pending_qty: pendingQty,
          original_qty: e?.quantity,
          rate: rate,
          gst: gst,
          discount: 0,
          sp_discount: 0,
          remarks: '',
          heat_no: '',
          plat_no: '',
          tc_no: '',
          isAuto: true,
        };
        return recalculate(base);
      });
      setAutoItemsData(mappedItems);
      setOriginalData(mappedItems);
    }
  }, [poItemsData, itemsArr]);

  const handleSubmit = async () => {

    if (!autoItemsData.some(item => item.require_qty > 0)) {
      toast.error("Please enter Receiving Qty for at least one item.");
      return;
    }

    const validQtyItems = autoItemsData?.filter((item) => item.require_qty > 0) || [];

    const hasInvalid = validQtyItems?.some((item) => {
      return (
        !item.require_qty || item.require_qty <= 0 ||
        !item.rate || item.rate <= 0
        // !item.heat_no
      );
    });

    if (hasInvalid) {
      toast.error("Please fill all required fields: Receiving Qty and Rate for each item.");
      return;
    }

    const updatedItems = validQtyItems.map((item) => ({
      from_id: item.from_id,
      detail_id: item.detail_id,
      item_id: item.item_id,
      item_no: item.item_no,
      quantity: item.require_qty,
      original_qty: item?.quantity,
      // item_length: item.item_length || 0,
      // item_width: item.item_width || 0,
      item_weight: item.item_weight || 0,
      // item_radius: item.item_radius || 0,
      // item_thickness: item.item_thickness,
      // assembly_weight: item.assembly_weight,
      // assembly_surface_area: item.assembly_surface_area,
      rate: item.rate,
      amount: item.amount,
      discount: item.discount,
      discount_amount: item.discount_amount,
      sp_discount: item.sp_discount,
      sp_discount_amount: item.sp_discount_amount,
      taxable_amount: item.taxable_amount,
      gst: item.gst,
      gst_amount: item.gst_amount,
      total_amount: item.total_amount,
      heat_no: item.heat_no,
      plat_no: item.plat_no,
      tc_no: item.tc_no,
      remarks: item.remarks,
      isAuto: item.isAuto,
    }));

    if (data?._id) {
      const payload = {
        id: data._id,
        items_details: JSON.stringify(updatedItems),
      };
      const resp = await axios.post(`${V_URL}/prosafe/pro-add-pu-item`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('PAY_USER_TOKEN')}` },
      });
      if (resp.data.success) {
        toast.success(resp.data.message);
        dispatch(getViewReceiveItems({ formData: { id: data._id } }));
        modal.hide();
      } else {
        toast.error(resp.data.message);
      }
    } else {
      setItemsArr(prev => [...prev, ...updatedItems]);
    }
    modal.hide();
    toast.success('Items added successfully');
  }

  return (
    <ModalWrapper
      title="Auto Items Details"
      isShown={modal.isShown}
      hide={modal.hide}
      footer={false}
      customSize={"modal-90w"}
    >
      <>
        <div className='row'>
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms custom-select-wpr">
              <label>PO No. <span className="login-danger">*</span></label>
              <MultiSelect
                value={selectedPo}
                options={poNoData?.map(e => ({ label: e.voucher_no, value: e.voucher_no }))}
                onChange={(e) => {
                  setSelectedPo(e.value);
                }}
                placeholder="Select PO No."
                className="w-100"
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className="table-responsive">
            <table className="table border-0 custom-table comman-table mb-0">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th>Item Name</th>
                  <th>Item No</th>
                  {/* <th>Length</th>
                  <th>Width</th> */}
                  {/* <th>Weight</th> */}
                  {/* <th>Radius</th>
                  <th>Thickness</th>
                  <th>Assembly Weight</th>
                  <th>Surface Area</th> */}
                  <th>Bal. PO Qty</th>
                  <th>Receiving Qty</th>
                  <th>Rate(₹)</th>
                  <th>Amount(₹)</th>
                  <th>Discount(%)</th>
                  <th>Discount Amount(₹)</th>
                  {/* <th>Sp. Discount(%)</th> */}
                  {/* <th>Sp. Discount Amount(₹)</th> */}
                  <th>Taxable Amount(₹)</th>
                  <th>GST(%)</th>
                  <th>GST Amount(₹)</th>
                  <th>Total Amount(₹)</th>
                  {/* <th>Heat/Lot No.</th> */}
                  {/* <th>Plat No.</th> */}
                  {/* <th>TC No.</th> */}
                  <th>Remarks</th>
                  <th className='text-end'>Action</th>
                </tr>
              </thead>
              <tbody>
                {autoItemsData?.map((elem, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{elem?.item}</td>
                    <td>{elem?.item_no}</td>
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.item_length || 0} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].item_length = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.item_length}
                    </td> */}
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.item_width || 0} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].item_width = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.item_width}
                    </td> */}
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.item_weight || 0} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].item_weight = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.item_weight}
                    </td> */}
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.item_radius || 0} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].item_radius = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : (elem.item_radius || "-")}
                    </td> */}
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.item_thickness} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].item_thickness = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : (elem.item_thickness || "-")}
                    </td> */}
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.assembly_weight || 0} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].assembly_weight = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.assembly_weight}
                    </td> */}
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.assembly_surface_area || 0} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].assembly_surface_area = parseFloat(e.target.value) || 0;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.assembly_surface_area}
                    </td> */}
                    <td>{elem.pending_qty}</td>
                    <td>
                      {isEditing ? (
                        <input type="number" className="form-control"
                          value={elem.require_qty} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].require_qty = parseFloat(e.target.value) || 0;
                            updated[i] = recalculate(updated[i]);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.require_qty}
                    </td>
                    <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.rate} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].rate = parseFloat(e.target.value) || 0;
                            updated[i] = recalculate(updated[i]);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.rate}
                    </td>
                    <td>{elem.amount?.toFixed(2)}</td>
                    <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.discount} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].discount = parseFloat(e.target.value) || 0;
                            updated[i] = recalculate(updated[i]);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.discount}
                    </td>
                    <td>{elem.discount_amount?.toFixed(2)}</td>
                    {/* <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.sp_discount} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].sp_discount = parseFloat(e.target.value) || 0;
                            updated[i] = recalculate(updated[i]);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.sp_discount}
                    </td>
                    <td>{elem.sp_discount_amount?.toFixed(2)}</td> */}
                    <td>{elem.taxable_amount?.toFixed(2)}</td>
                    <td>
                      {isEditing ? (
                        <input type="number" className="form-control table-input"
                          value={elem.gst} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].gst = parseFloat(e.target.value) || 0;
                            updated[i] = recalculate(updated[i]);
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.gst}
                    </td>
                    <td>{elem.gst_amount?.toFixed(2)}</td>
                    <td>{elem.total_amount?.toFixed(2)}</td>
                    {/* <td>
                      {isEditing ? (
                        <input type="text" className="form-control table-input"
                          value={elem.heat_no} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].heat_no = e.target.value;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.heat_no || "-"}
                    </td>
                    <td>
                      {isEditing ? (
                        <input type="text" className="form-control table-input"
                          value={elem.plat_no} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].plat_no = e.target.value;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.plat_no || "-"}
                    </td>
                    <td>
                      {isEditing ? (
                        <input type="text" className="form-control table-input" value={elem.tc_no}
                          style={{ width: "150px" }} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].tc_no = e.target.value;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.tc_no || "-"}
                    </td> */}
                    <td>
                      {isEditing ? (
                        <textarea rows={1} className="form-control table-input" value={elem.remarks}
                          style={{ width: "150px" }} onChange={(e) => {
                            const updated = [...autoItemsData];
                            updated[i].remarks = e.target.value;
                            setAutoItemsData(updated);
                          }}
                        />
                      ) : elem.remarks || "-"}
                    </td>
                    <td className="d-flex justify-content-end">
                      <a className="action-icon p-1 mx-1" onClick={() => {
                        const filtered = autoItemsData?.filter((_, index) => index !== i);
                        setAutoItemsData(filtered);
                      }}>
                        <Trash2 />
                      </a>
                    </td>
                  </tr>
                ))}
                {autoItemsData?.length === 0 ? (
                  <tr>
                    <td colSpan="999">
                      <div className="no-table-data">
                        No Data Found!
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
          <div className="mt-3 text-end">
            {/* {isEditing ? (
              <>
                <button className="btn btn-success mx-2" onClick={() => {
                  setIsEditing(false);
                  handleSubmit();
                }}>
                  <Save className="me-1" /> Save
                </button>
                <button className="btn btn-secondary mx-2" onClick={() => {
                  setAutoItemsData([...originalData]);
                  setIsEditing(false);
                }}>
                  <X className="me-1" /> Cancel
                </button>
              </>
            ) : (
              <button className="btn btn-outline-primary mx-2" onClick={() => setIsEditing(true)}>
                <Pencil className="me-1" /> Edit All
              </button>
            )} */}
            <button className="btn btn-secondary mx-2" onClick={() => {
              setAutoItemsData([...originalData])
              modal.hide()
            }}>
              <X className="me-1" /> Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </>
    </ModalWrapper>
  )
}

export default AutoReceiveModel